import React from 'react'
import { oneOfType, object, string } from 'prop-types'
import { Global } from '@emotion/react'
import '@livechat/design-system-react-components/dist/style.css'
import 'normalize.css'
import mediaQueries from './media-queries'

const styles = (theme) => ({
  '[class*="lc-Button-module"], [class*="lc-Typography-module"], [class*="lc-Link-module"], [class*="lc-PickerList-module"]':
    {
      fontFamily:
        "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
    },
  // Fix for flashing border on hover-out in DS Picker List Item
  'div[class*="lc-PickerListItem-module__picker-list__item"][aria-current="true"]':
    {
      borderColor: 'transparent',
    },
  body: {
    fontFamily: theme.fontFamily,
    fontSize: theme.fontSize,
    padding: 0,
    margin: 0,
    WebkitFontSmoothing: 'antialiased',
    color: theme.colors.black,
    lineHeight: 1.5,
  },
  h4: {
    fontSize: '26px',
    lineHeight: '31px',
    letterSpacing: '0.005em',

    [mediaQueries.smallScreen()]: {
      fontSize: '24px',
      lineHeight: '29px',
    },

    [mediaQueries.mediumScreen()]: {
      fontSize: '32px',
      lineHeight: '38px',
    },
  },
  h5: {
    fontSize: '22px',
    lineHeight: '26px',
    letterSpacing: '0.005em',

    [mediaQueries.smallScreen()]: {
      fontSize: '24px',
      lineHeight: '29px',
    },
  },
  small: {
    fontSize: '15px',
    lineHeight: '150%',

    [mediaQueries.smallScreen()]: {
      fontSize: '16px',
      lineHeight: '19px',
    },
  },
  a: {
    textDecoration: 'none',
  },
  '*, *::after, *::before': {
    boxSizing: 'border-box',
  },
})

export default function GlobalStyles({ customStyles }) {
  return <Global styles={[styles, customStyles]} />
}

GlobalStyles.propTypes = {
  customStyles: oneOfType([object, string]),
}
